import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { connectFC } from '../../../utils/connectFC';
import { PromotionSummaryFC, PromotionSummaryFCProps } from './PromotionSummaryFC';

const useStrings = (): PromotionSummaryFCProps['strings'] => {
  const intl = useIntl();

  return useMemo(
    () => ({
      exampleBasePrice: intl.formatMessage({ id: 'components.PromotionSummary.exampleBasePrice' }),
      exampleDescription: intl.formatMessage({
        id: 'components.PromotionSummary.exampleDescription',
      }),
      exampleDiscountedPrice: intl.formatMessage({
        id: 'components.PromotionSummary.exampleDiscountedPrice',
      }),
      exampleTitle: intl.formatMessage({ id: 'components.PromotionSummary.exampleTitle' }),
      exampleTooltip: intl.formatMessage({ id: 'components.PromotionSummary.exampleTooltip' }),
      durationTitle: intl.formatMessage({ id: 'components.PromotionSummary.durationTitle' }),
      exampleType: intl.formatMessage({ id: 'components.PromotionSummary.exampleType' }),
      promotionTitle: intl.formatMessage({ id: 'components.PromotionSummary.promotionTitle' }),
      appliesToItemsTitle: intl.formatMessage({
        id: 'components.PromotionSummary.appliesToItemsTitle',
      }),
      viewAll: intl.formatMessage({ id: 'components.PromotionSummary.viewAll' }),
    }),
    [intl],
  );
};

type PromotionSummaryProps = Omit<PromotionSummaryFCProps, 'strings'>;

export const PromotionSummary = connectFC(PromotionSummaryFC, (props: PromotionSummaryProps) => {
  const strings = useStrings();

  return { ...props, strings };
});
